import { render } from "./QuestionItem.vue?vue&type=template&id=1a1a6e00&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"

import "./QuestionItem.vue?vue&type=style&index=0&id=1a1a6e00&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1a6e00"]])

export default __exports__